module.exports = __webpack_public_path__ + "static/media/S.b146e88d.svg";